module.exports = __webpack_public_path__ + "images/emails/dkim/weak-dkim-a80eb89a.png";